import { render, staticRenderFns } from "./IconReports.vue?vue&type=template&id=34f2c97e"
import script from "./IconReports.vue?vue&type=script&lang=ts"
export * from "./IconReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports